import React, { Component } from 'react';
import { connect } from "react-redux"
import _ from 'lodash';
import agent from '../../agent'
import { Field, reduxForm, FormSection } from 'redux-form';
import classNames from 'classnames';
import Nestable from 'react-nestable';
import ReactQuill from 'react-quill';
import renderField from "./renderField";
import SortableForm from "./SortableForm";

import CloseButton from '../../assets/images/close-dark.png';

class TestForm extends Component {
	state = {
		
	}

	componentWillReceiveProps(nextProps) {
		
	}

    onChangeContent = ordinal => e => {
    
  	}

	render() {
		const { handleSubmit, pristine, submitting, error } = this.props
		const showResults = values =>
  			window.alert(`You submitted:\n\n${JSON.stringify(values, null, 2)}`);
		return (
			<div>
		      <h2>Sortable form using react-sortable-hoc and redux-form</h2>
		      <SortableForm onSubmit={showResults}>
		        <Field
		          name="artist.resume[firstName]"
		          type="text"
		          component={renderField}
		          label="First Name"
		        />
		        <Field
		          name="artist.resume[lastName]"
		          type="text"
		          component={renderField}
		          label="Last Name"
		        />
		        <Field
		          name="artist.resume[street]"
		          type="text"
		          component={renderField}
		          label="Street"
		        />
		      </SortableForm>
		    </div>
		);
	}
}


TestForm = reduxForm({
	form: 'ArtistTestForm', // <------ same form name
  	destroyOnUnmount: false, // <------ preserve form data
  	forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(TestForm)

const mapStateToProps = state => ({
  
});

const mapDispatchToProps = dispatch => ({
	
});

export default connect(mapStateToProps, mapDispatchToProps)(TestForm);



// WEBPACK FOOTER //
// ./src/components/profile/TestForm.js